module.exports = __webpack_public_path__ + "img/tat.e318eea7.png";